import { Stack } from "@mui/material";

import { ExportFormModalityOptions } from "./components/ExportFormModalityOptions";
import { ExportFormOptions } from "./components/ExportFormOptions";
import { ExportModality } from "./constants";

interface ExportFormProps {
  exportModality: ExportModality;
  isDisabled?: boolean;
}

export const ExportForm = (props: ExportFormProps) => {
  const { exportModality, isDisabled } = props;

  return (
    <Stack
      component="fieldset"
      disabled={isDisabled}
      direction="row"
      gap={8}
      sx={{
        border: "none",
        margin: 0,
        padding: 0,
        flex: 1,
        alignItems: "stretch",
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? "none" : "auto",
      }}
    >
      <ExportFormModalityOptions exportModality={exportModality} />
      <ExportFormOptions exportModality={exportModality} />
    </Stack>
  );
};
